import { CoreToolboxComponentIds } from "@inter-ikea-core/core-toolbox";
/**
 * Stores a reference to the IPEX viewer (not to be confused with the ViewerComponent
 * which stores a reference to the Viewer interface used internally by Core).
 *
 * This is the one you want to use in a planner as the IViewer interface contains all functionality
 * offered by the IPEX viewer which Core's internal Viewer-interface only has the functionality
 * necessary internally for Core to work.
 */
export class IpexViewerComponent {
    viewer;
    static ID = CoreToolboxComponentIds.IpexViewerComponentId;
    typeId = IpexViewerComponent.ID;
    // Since viewers may change between snapshots we must recreate this
    doStoreInSnapshot = false;
    constructor(viewer) {
        this.viewer = viewer;
    }
    eq(other) {
        return other.viewer === this.viewer;
    }
}
//# sourceMappingURL=IpexViewerComponent.js.map